var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18683 16.1868C0.737724 16.6359 0.737724 17.3641 1.18683 17.8132C1.63593 18.2623 2.36407 18.2623 2.81317 17.8132L1.18683 16.1868ZM18.15 2C18.15 1.36487 17.6351 0.85 17 0.85H6.65C6.01487 0.85 5.5 1.36487 5.5 2C5.5 2.63513 6.01487 3.15 6.65 3.15H15.85V12.35C15.85 12.9851 16.3649 13.5 17 13.5C17.6351 13.5 18.15 12.9851 18.15 12.35V2ZM2.81317 17.8132L17.8132 2.81317L16.1868 1.18683L1.18683 16.1868L2.81317 17.8132Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatch);
export default __webpack_public_path__ + "static/media/batch.35dc5b38.svg";
export { ForwardRef as ReactComponent };